import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../firebase/firebase";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(undefined); // Default to undefined to avoid flashing

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            console.log("🔥 Auth state changed:", user);
            setUser(user);
        });

        return () => unsubscribe();
    }, []);

    const login = async (email, password) => {
        try {
            console.log("🚀 Attempting login with email:", email);
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            console.log("✅ Login successful!", userCredential.user);
            setUser(userCredential.user);
        } catch (error) {
            console.error("❌ Firebase Login Error:", error.code, error.message);
            alert(`Login Failed: ${error.message}`);
        }
    };

    const logout = async () => {
        try {
            console.log("🔓 Logging out...");
            await signOut(auth);
            console.log("✅ Logout successful!");
            setUser(null);
        } catch (error) {
            console.error("❌ Logout Error:", error);
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
